import React from 'react';
import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import '../css/TermsAndPrivacyPolicy.css';

const TermsAndPrivacyPolicy = () => {
  const today = new Date().toLocaleDateString("en-IN", {
    day: "2-digit", month: "long", year: "numeric",
  });

  return (
    <>
      <Navbar />
      <br /><br /><br /><br />

      <div className="tp-hero">
        <h1>Legal Documents</h1>
        <p>Al-Qaim Welfare Foundation — Registered Non-Profit Charitable Organization</p>
        <span className="tp-updated">Last Updated: {today}</span>
      </div>

      <div className="terms-privacy-container">

        {/* ─── TERMS OF USE ─── */}
        <div className="terms-section">
          <h1><strong>Terms of Use</strong></h1>
          <p className="tp-intro">
            These Terms of Use ("Terms") constitute a legally binding agreement between you ("User") and
            Al-Qaim Welfare Foundation ("AQWF", "Foundation", "we", "us", or "our"), a charitable
            organization operating for public benefit. By accessing or using this Website, you unconditionally
            accept these Terms. If you do not agree, you must discontinue use immediately.
          </p>

          <h2>1. Legal Status & Registration</h2>
          <p>
            Al-Qaim Welfare Foundation is a registered non-profit charitable organization operating under
            applicable Indian laws. All activities are conducted in compliance with the Foreign Contribution
            (Regulation) Act (FCRA) where applicable, the Income Tax Act 1961 (Sections 80G & 12A), and
            relevant state legislation governing public charitable trusts and societies. Our registration
            details are available upon request.
          </p>

          <h2>2. Acceptance of Terms</h2>
          <p>
            By accessing this Website, submitting any form, making any donation, or engaging with any service
            offered by AQWF, you agree to be legally bound by these Terms, our Privacy Policy, and any
            additional guidelines published by us. These Terms apply to all visitors, donors, beneficiaries,
            volunteers, members, and any other users.
          </p>

          <h2>3. Permitted Use</h2>
          <p>You may use this Website solely for lawful purposes. You agree <strong>not</strong> to:</p>
          <ul>
            <li>Misrepresent your identity or provide false information in any form or application.</li>
            <li>Submit fraudulent requests for aid, membership, or volunteer registration.</li>
            <li>Use the Foundation's name, logo, or identity for unauthorized commercial, political, or personal activities.</li>
            <li>Interfere with, disrupt, or attempt to gain unauthorized access to the Website or its systems.</li>
            <li>Use the Website to harass, defame, or harm individuals or communities.</li>
            <li>Engage in scraping, data mining, or automated access without written permission.</li>
          </ul>

          <h2>4. Donations & Financial Transactions</h2>
          <p>
            All donations made through this Website are voluntary contributions to AQWF for charitable
            purposes. By making a donation:
          </p>
          <ul>
            <li>You confirm that the funds are lawfully owned and not derived from any illegal activity.</li>
            <li>You acknowledge that donations are <strong>non-refundable</strong> except at the sole discretion of AQWF in cases of proven technical error.</li>
            <li>You consent to the use of your donation for charitable activities as determined by AQWF's governing board.</li>
            <li>Donation receipts eligible for tax exemption under Section 80G of the Income Tax Act 1961 will be issued subject to applicable rules and our registration status at the time of donation.</li>
            <li>AQWF is not liable for failed transactions due to third-party payment gateway errors. In such cases, please contact your bank or payment provider directly.</li>
            <li>All online transactions are processed through PCI-DSS compliant payment gateways (such as Razorpay or equivalent). AQWF does not store your card or banking credentials.</li>
            <li>For Zakat, Fitrah, Khums, Sadqah, and other religious donations, AQWF ensures utilization as per Islamic principles and the donor's declared intent.</li>
          </ul>

          <h2>5. Payment Gateway Disclaimer</h2>
          <p>
            Online payment processing is facilitated by authorized third-party payment service providers.
            AQWF shall not be responsible for any unauthorized transactions, failed payments, or security
            breaches attributable to the payment gateway. By proceeding with a payment, you agree to the
            terms and conditions of the respective payment gateway provider. Disputes related to payment
            processing must be addressed directly with the gateway provider and your financial institution.
          </p>

          <h2>6. Aid & Welfare Services</h2>
          <p>
            AQWF provides charitable aid (medical, educational, ration, and other forms) at its sole
            discretion based on need assessment and available resources. Submission of an aid request does
            not guarantee assistance. AQWF reserves the right to verify all submitted information and
            reject fraudulent or ineligible applications. Provision of false information may result in
            permanent disqualification and, where warranted, referral to appropriate authorities.
          </p>

          <h2>7. Volunteer & Member Obligations</h2>
          <p>
            Volunteers and members of AQWF are bound by the Member/Volunteer Agreement signed at the time
            of registration. Misuse of the Foundation's name, resources, or identity — including for
            political, commercial, or personal gain — is strictly prohibited and may result in immediate
            termination and legal action.
          </p>

          <h2>8. Intellectual Property</h2>
          <p>
            All content on this Website — including text, images, logos, design elements, and code — is
            the exclusive intellectual property of AQWF and is protected under Indian copyright law
            (Copyright Act, 1957) and applicable international treaties. Unauthorized reproduction,
            distribution, or commercial use is strictly prohibited. For permission requests, contact us.
          </p>

          <h2>9. Disclaimer of Warranties</h2>
          <p>
            This Website and its content are provided on an "as is" and "as available" basis without
            warranties of any kind, express or implied. AQWF does not warrant the accuracy, completeness,
            or timeliness of information. Use of this Website is at your own risk.
          </p>

          <h2>10. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, AQWF and its trustees, officers, employees, and
            volunteers shall not be liable for any direct, indirect, incidental, consequential, or punitive
            damages arising from the use of or inability to use this Website or its services.
          </p>

          <h2>11. Modifications</h2>
          <p>
            AQWF reserves the right to modify these Terms at any time. Changes take effect upon posting
            to this page. Continued use of the Website after changes constitutes acceptance. It is your
            responsibility to review these Terms periodically.
          </p>

          <h2>12. Governing Law & Dispute Resolution</h2>
          <p>
            These Terms are governed by the laws of the Republic of India. Any disputes arising from these
            Terms or use of this Website shall be subject to the exclusive jurisdiction of the courts in
            Mumbai, Maharashtra, India. AQWF encourages resolution of disputes through good-faith
            negotiation before initiating legal proceedings.
          </p>

          <h2>13. Contact</h2>
          <p>
            For legal inquiries, write to: <strong>alqaimwelfareinfo@gmail.com</strong><br />
            Phone: +91-7400231537 / +91-7738805577
          </p>
        </div>

        {/* ─── PRIVACY POLICY ─── */}
        <div className="privacy-section">
          <h1><strong>Privacy Policy</strong></h1>
          <p className="tp-intro">
            Al-Qaim Welfare Foundation is committed to protecting your personal information. This Privacy
            Policy explains how we collect, use, disclose, and safeguard your data in compliance with the
            Information Technology Act, 2000, the IT (Amendment) Act, 2008, and the Digital Personal Data
            Protection Act, 2023 (DPDPA 2023) of India.
          </p>

          <h2>1. Information We Collect</h2>
          <p><strong>Personal Information:</strong> When you fill out forms, register as a member/volunteer,
          request aid, or make a donation, we collect: full name, father's name, address, email address,
          phone/WhatsApp number, Aadhar number, and other submitted details.</p>
          <p><strong>Financial Information:</strong> When you make a donation, transaction details are
          processed by our payment gateway. AQWF does not store credit/debit card or net banking credentials.</p>
          <p><strong>Documents:</strong> Uploaded documents (Aadhar cards, medical reports, etc.) are stored
          securely on encrypted cloud storage for verification purposes only.</p>
          <p><strong>Usage Data:</strong> We may collect technical data such as IP address, browser type,
          device information, and pages visited for website improvement and security.</p>

          <h2>2. Purpose of Data Collection</h2>
          <ul>
            <li>To process and manage aid requests, donations, and registrations.</li>
            <li>To verify eligibility for charitable assistance.</li>
            <li>To issue tax exemption receipts (80G) for donations.</li>
            <li>To communicate updates, activity reports, and program information.</li>
            <li>To comply with legal, regulatory, and auditing requirements.</li>
            <li>To improve our Website and services.</li>
          </ul>

          <h2>3. Legal Basis for Processing</h2>
          <p>
            We process your data on the basis of: (a) your explicit consent given at the time of submission;
            (b) contractual necessity (e.g., processing donations); (c) compliance with legal obligations;
            and (d) our legitimate interests as a charitable organization, where such interests do not
            override your fundamental rights.
          </p>

          <h2>4. Aadhar & Sensitive Personal Data</h2>
          <p>
            Collection of Aadhaar information is strictly for identity verification in compliance with
            the Aadhaar (Targeted Delivery of Financial and Other Subsidies, Benefits and Services) Act,
            2016. We do not use Aadhaar data for any purpose other than stated above, and we do not share
            it with unauthorized third parties. Sensitive personal data is stored with enhanced security
            measures.
          </p>

          <h2>5. Data Sharing & Disclosure</h2>
          <p>We do not sell or rent your personal data. We may share it only:</p>
          <ul>
            <li>With authorized AQWF volunteers/members for aid delivery purposes, on a need-to-know basis.</li>
            <li>With payment gateway service providers (such as Razorpay) strictly for processing transactions.</li>
            <li>With cloud storage providers (such as Cloudinary) for secure document storage.</li>
            <li>With government authorities or law enforcement if required by law or court order.</li>
            <li>With auditors and legal advisors bound by confidentiality obligations.</li>
          </ul>

          <h2>6. Data Retention</h2>
          <p>
            We retain personal data for as long as necessary to fulfil the purpose for which it was
            collected, or as required by law. Aid request records are retained for a minimum of 7 years
            for audit and accountability purposes. Donation records may be retained as required under
            Indian tax law. You may request deletion of your data subject to our legal obligations.
          </p>

          <h2>7. Your Rights</h2>
          <p>Under applicable Indian data protection law, you have the right to:</p>
          <ul>
            <li>Access the personal data we hold about you.</li>
            <li>Correct inaccurate or incomplete data.</li>
            <li>Withdraw consent for processing (where consent is the legal basis).</li>
            <li>Request erasure of your data, subject to legal obligations.</li>
            <li>Lodge a complaint with the Data Protection Board of India (once operational under DPDPA 2023).</li>
          </ul>
          <p>To exercise these rights, contact us at <strong>alqaimwelfareinfo@gmail.com</strong>.</p>

          <h2>8. Cookies & Tracking</h2>
          <p>
            Our Website may use cookies and similar technologies to enhance user experience and analyze
            traffic. Essential cookies are necessary for Website functionality. Analytics cookies help
            us understand usage patterns. You may adjust your browser settings to reject non-essential
            cookies; however, this may affect Website functionality.
          </p>

          <h2>9. Security Measures</h2>
          <p>
            We implement industry-standard technical and organizational security measures including
            SSL/TLS encryption, secure cloud storage, access controls, and regular security reviews.
            However, no method of internet transmission is 100% secure. In the event of a data breach
            that poses a risk to your rights, we will notify affected users as required by law.
          </p>

          <h2>10. Children's Privacy</h2>
          <p>
            This Website is not directed at children under 18. If we become aware that we have
            collected personal data from a minor without verifiable parental consent, we will take
            steps to delete such information promptly. Beneficiary data involving minors (e.g.,
            educational or medical aid) is collected solely for aid purposes with guardian consent.
          </p>

          <h2>11. Third-Party Links</h2>
          <p>
            This Website may contain links to third-party websites. AQWF is not responsible for the
            privacy practices or content of those sites. We recommend reviewing the privacy policies
            of any third-party websites you visit.
          </p>

          <h2>12. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy periodically to reflect changes in law, our practices,
            or services. Material changes will be communicated via this page with an updated effective
            date. Your continued use of the Website after changes constitutes acceptance.
          </p>

          <h2>13. Grievance Officer</h2>
          <p>
            In accordance with the Information Technology Act, 2000 and applicable rules, the name and
            contact details of the Grievance Officer are:<br />
            <strong>Al-Qaim Welfare Foundation — Grievance Officer</strong><br />
            Email: <strong>alqaimwelfareinfo@gmail.com</strong><br />
            Phone: +91-7400231537<br />
            Response Time: Within 30 days of receipt of grievance.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsAndPrivacyPolicy;